import { Box, SkeletonCircle, SkeletonText } from '@chakra-ui/react';
import { ReactNode } from 'react';

export interface LoadingSkeletonProps {
  isLoaded?: boolean;
  skeletonLineCount?: number;
  children?: ReactNode;
}

export const LoadingSkeleton = (props: LoadingSkeletonProps) => {
  const { isLoaded = true, skeletonLineCount = 4, children } = props;

  const skeleton = (
    <Box padding="6" boxShadow="lg">
      <SkeletonCircle size="10" />
      <SkeletonText mt="4" noOfLines={skeletonLineCount} spacing="4" />
    </Box>
  );

  if (isLoaded) {
    return <>{children}</>;
  } else {
    return skeleton;
  }
};
